import { useTranslation } from "@impero-com/common/utils/i18n";

import { ExportModal, ExportModalOption } from "components/modals/ExportModal";

export type TestingActivityExportModalSubmitType = "WITH_ANSWERS" | "NORMAL";

interface TActExportModalProps {
    onSubmit: (type: TestingActivityExportModalSubmitType) => void;
    onClose: () => void;
    open: boolean;
    loading: boolean;
}

export function TestingActivityExportModal({
    onSubmit,
    onClose,
    open,
    loading,
}: TActExportModalProps) {
    const { t } = useTranslation();

    const options: ExportModalOption<TestingActivityExportModalSubmitType>[] = [
        {
            value: "NORMAL",
            label: t("TestingActivities_NormalExport"),
        },
        {
            value: "WITH_ANSWERS",
            label: t("TestingActivities_ExportWithAnswers"),
        },
    ];

    return (
        <ExportModal
            onSubmit={onSubmit}
            onClose={onClose}
            open={open}
            loading={loading}
            title={t("TestingActivities_ExportModalTitle")}
            options={options}
            defaultValue="NORMAL"
        />
    );
}
